import { render, staticRenderFns } from "./SeparatorWithText.vue?vue&type=template&id=187f7210&scoped=true&"
import script from "./SeparatorWithText.vue?vue&type=script&lang=js&"
export * from "./SeparatorWithText.vue?vue&type=script&lang=js&"
import style0 from "./SeparatorWithText.vue?vue&type=style&index=0&id=187f7210&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187f7210",
  null
  
)

export default component.exports